import { createContext, type ReactNode } from 'react';

export interface AppHeaderLeadContextValue {
  setLead: (node: ReactNode) => void;
  clearLead: () => void;
}

export const AppHeaderLeadContext = createContext<AppHeaderLeadContextValue>({
  setLead: () => {},
  clearLead: () => {},
});
